var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppWrapper',{key:_vm.refreshComponent,attrs:{"load":_vm.loadScreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }